/**
 * Type of alcoholic drinks.
 */
export type AlcoholicDrinkType =
  | 'BEER'
  | 'GRAPE_WINE'
  | 'CHAMPAGNE'
  | 'SPIRIT'
  | 'OTHER';

export const AlcoholicDrinkType = {
  Beer: 'BEER' as AlcoholicDrinkType,
  GrapeWine: 'GRAPE_WINE' as AlcoholicDrinkType,
  Champagne: 'CHAMPAGNE' as AlcoholicDrinkType,
  Spirit: 'SPIRIT' as AlcoholicDrinkType,
  Other: 'OTHER' as AlcoholicDrinkType,
};
